
enum Type {
    FACEBOOK = "facebook",
    GOOGLE = "google"
}

export { Type as ProviderType }